import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=6a597488&scoped=true"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"
import style0 from "./Mailing.vue?vue&type=style&index=0&id=6a597488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a597488",
  null
  
)

export default component.exports